import { scrollToId } from "@/lib/site";

const NAV = [
  { label: "Consultation Pathways", id: "packages" },
  { label: "Meet Dr. Santhisree", id: "doctor" },
  { label: "How It Works", id: "how-it-works" },
  { label: "FAQ", id: "faq" },
];

export default function Header({ onRequest }) {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 bg-[#FAF7F2]/85 backdrop-blur-xl border-b border-[#E5D3AD]/50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 lg:h-[72px] flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center"
          aria-label="Sree Prathama Ayurvedam — back to top"
        >
          <img
            src="/logo.png"
            alt="Sree Prathama Ayurvedam"
            data-testid="header-logo-img"
            className="h-9 lg:h-11 w-auto"
          />
        </button>

        <nav className="hidden lg:flex items-center gap-8" data-testid="header-nav">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => scrollToId(n.id, `nav_${n.id}`)}
              className="text-sm text-[#2D3A32] hover:text-[#1B3B2B] transition-colors duration-300 relative after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-[#C5A059] after:transition-all after:duration-300 hover:after:w-full"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="header-request-consultation-btn"
            onClick={() => onRequest()}
            className="bg-[#1B3B2B] text-[#FAF7F2] text-xs lg:text-sm font-semibold tracking-wide px-4 lg:px-6 py-2.5 lg:py-3 rounded-full hover:bg-[#132C20] transition-colors duration-300 shadow-[0_8px_24px_rgb(27,59,43,0.18)]"
          >
            Request Consultation
          </button>
        </div>
      </div>
    </header>
  );
}
